module.exports = __webpack_public_path__ + "media/public/fonts/QanelasRegular/QanelasRegular-9e3c1bdb55b3de6847b9075506a77b19.svg";